<template lang="pug">
    d2-container()
        el-form(:model="form",:inline="false", ref="form", label-width="100px",  label-suffix=":", @keyup.enter.native="formSubmit()")
            el-form-item(label="Banner" prop="img")
                el-input(v-model="form.img" v-show="false")
                //- el-upload(:http-request="uploadSectionFile",action="useless" :headers="headers", :before-upload="beforeAvatarUpload" :show-file-list="false" class="avatar-uploader")
                img(v-if="imageUrl" :src="imageUrl"  @click="openImgdailog" style='width:375px;height:175px')
                i(v-else class="el-icon-plus avatar-uploader-icon" @click="openImgdailog")
                imgupload(v-if="openImg" ref="upimg" :width="375" :height="175" @uploadSuccess='doneup')
            el-form-item(label="积分榜行数" prop="rowCount")
                  el-select.sel_width_ct(v-model='form.rowCount' placeholder="请选择积分榜行数" clearable)
                      el-option(label="10" :value='10')
                      el-option(label="20" :value='20')
                      el-option(label="30" :value='30')
                      el-option(label="50" :value='50')
                      el-option(label="100" :value='100')
                      el-option(label="200" :value='200')
        el-button(type="primary" @click="formSubmit()" v-if="isAuth('pb:score:save')"  ) 保 存
</template>
<script>
    import util from '@/libs/util.js'
    export default {
        data () {
            return {
                uploadUrl: this.$http.adornUrl(`/upload/uploadFile`),
                uploadData: null,
                //文件上传时授权
                headers: {
                    token: util.cookies.get('token'),
                    authorization: 'Bearer ' + util.cookies.get('authorization'),
                    'Content-Type': 'application/json; charset=utf-8'
                },
                form: {
                    id: null,
                    img: '',
                    rowCount: ''
                },
                imageUrl: '',
                openImg: false,
                uurrll: ''
            }
        },
        created () {
            this.getImg()
        },
        methods: {
            getfile (e) {
                let that = this
                console.log(e, 888)
                //实例化FileReader API
                var file = e.target.files[0]
                var freader = new FileReader()
                freader.readAsDataURL(file)
                freader.onload = function (e) {
                  that.uurrll = e.target.result //显示图片
                }
            },
            // 查询
            getImg () {
                this.$http({
                    url: this.$http.adornUrl(`/pbScoreboard/getId/`),
                    method: 'get'
                }).then((data) => {
                    if (data && data.code === 0) {
                        console.log('积分榜数据：', data)
                        if (data.bean.url !== '' && data.bean.url != null) {
                            // this.imageUrl = 'data:image/png;base64,' + data.bean.url
                            this.imageUrl = data.bean.url
                            this.form.rowCount = data.bean.rowCount
                        }
                    }
                })
            },
            //保存
            formSubmit () {
                if (this.form.img === '') return this.$message.error('请上传banner后再保存！')
                this.$http({
                    url: this.$http.adornUrl(`/pbScoreboard/save/`),
                    method: 'post',
                    data: {
                        img: this.form.img,
                        rowCount: this.form.rowCount
                    }
                }).then((data) => {
                    console.log(data)
                    if (data && data.code === 0) {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                })
            },

            doneup (val, url) {
              this.form.img = val
              this.imageUrl = url
            },
            openImgdailog () {
                this.openImg = true
                this.$nextTick(() => {
                    this.$refs.upimg.init('pbScoreboard') //传入图片类型参数
                })
            },
            //文件上传前的验证
            beforeAvatarUpload (file) {
                const isJPG = file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'image/jpeg'
                const isLt2M = file.size / 1024 / 1024 < 2

                if (!isJPG) {
                    this.$message.error('上传图片只能是 jpg,jpeg,png 格式!')
                }
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 2MB!')
                }
                return isJPG && isLt2M
            },
            //自定义上传方法
            //没有用el-upload的action方法，如果使用要传递headers属性参数授权
            uploadSectionFile (param) {
                let fd = new FormData()
                fd.append('type', 'pbScoreboard')
                fd.append('file', param.file)

                this.$http({
                    url: this.$http.adornUrl(`/upload/uploadFile`),
                    method: 'post',
                    data: fd
                }).then((data) => {
                    if (data && data.code === 0) {
                        this.form.img = data.bean.id
                        this.imageUrl = URL.createObjectURL(param.file)
                        this.$message.success('上传成功!')
                    } else {
                        this.$message.error('上传失败!')
                    }
                })
            }
        }
    }
</script>
<style>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>
